import React from 'react'
import './Status.css'

const StatusSuccess = (props) => (
  <div className='status status--suc'>{props.children}</div>
)

const StatusError = (props) => (
  <div className='status status--err'>{props.children}</div>
)

export { StatusSuccess, StatusError }
